"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tools = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var OrderListActions = require("@caddigital/sok-reducers/lib/actions/order/list");
var Types = require("types");
var translate_1 = require("utils/translate");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        cartSelectionsLength: state.cart.data.items.length,
        cartItems: state.cart.data.items,
        selectedLanguage: selectedLanguage,
        filter: state.order.list.filter
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetchOrderList: function (folder, filter) {
        return dispatch(OrderListActions.fetchOrderListRequest(folder, filter));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.withState)('filtersIsOpen', 'toggleFilters', false), recompose_1.pure);
exports.Tools = enhance(function (props) { return (React.createElement("div", { className: 'orders-view-tools' },
    React.createElement(sok_ui_1.Button, { url: "/".concat(props.selectedLanguage, "/projects/").concat(props.currentProject.id, "/orders/create"), color: 'blue', className: 'text-left', text: (0, translation_1.getLocalization)('userfront/orders/newOrder'), icon: React.createElement(Icon_1.Icon, { className: 'fa-plus' }) }),
    React.createElement(sok_ui_1.Dropdown2, { className: 'filter-list-dropdown' },
        React.createElement(sok_ui_1.Button, { color: 'dark-gray', border: 'yellow', className: 'text-left', text: (0, translation_1.getLocalization)('userfront/orders/filters'), icon: React.createElement(Icon_1.Icon, { key: "icon", className: "fa-filter" }), iconRight: React.createElement(Icon_1.Icon, { key: "right-icon", className: "fa-chevron-down" }) }),
        React.createElement(sok_ui_1.Dropdown2Menu, null,
            React.createElement(sok_ui_1.Dropdown2MenuItem, { key: "my-orders", onClick: function (e) {
                    e.preventDefault();
                    props.fetchOrderList(props.currentFolder, 'only-my');
                } },
                React.createElement("span", null,
                    React.createElement(sok_ui_1.Input, { className: 'filter', type: 'radio', name: 'selected', onChange: function () { return false; }, label: (0, translation_1.getLocalization)('userfront/orders/myOrders'), value: props.filter === 'only-my' }))),
            React.createElement(sok_ui_1.Dropdown2MenuItem, { key: "all-orders", onClick: function (e) {
                    e.preventDefault();
                    props.fetchOrderList(props.currentFolder, 'all');
                } },
                React.createElement("span", null,
                    React.createElement(sok_ui_1.Input, { className: 'filter', type: 'radio', name: 'selected', onChange: function () { return false; }, label: (0, translation_1.getLocalization)('userfront/orders/allOrders'), value: props.filter === 'all' }))))))); });
